import { render, staticRenderFns } from "./MLink.vue?vue&type=template&id=e572c414"
import script from "./MLink.vue?vue&type=script&lang=js"
export * from "./MLink.vue?vue&type=script&lang=js"
import style0 from "./MLink.vue?vue&type=style&index=0&id=e572c414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports